// @flow
import React from 'react';
import styled from 'styled-components';
import { background, border, color, compose, flexbox, grid, layout, position, shadow, space, typography } from 'styled-system';
type Props = {
  component: 'td' | 'th';
};

// To avoid passing unintended attributes to the element directly,
// one solution is go under styled-components for clean up.
// This will avoid errors like "React does not recognize the `myCustom` prop on a DOM element."
const componentMapping = {
  td: styled.td``,
  th: styled.th``
};
const TableCell = ({
  component = 'td',
  ...rest
}: Props) => {
  const Component = componentMapping[component] || componentMapping.td;
  return <Component {...rest} data-sentry-element="Component" data-sentry-component="TableCell" data-sentry-source-file="TableCell.tsx" />;
};
const styleProps = compose(background, border, color, flexbox, grid, layout, position, shadow, space, typography);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const StyledTableCell = styled<any>(TableCell)`
  display: table-cell;
  padding: 16px;
  text-align: left;
  vertical-align: inherit;
  white-space: nowrap;
  text-overflow: ellipsis;

  ${styleProps}
`;
export { StyledTableCell as TableCell };